export const noop: () => null = () => null;
